import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../Components/Sidebar";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchCQADescriptionData, updateCQADescriptionData } from "../../redux/actions/CQAAction";
import PageComponent from "../../Components/PageComponent";

function CQAAddDescription() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    data: CQADescription = [],
    loading,
    error,
  } = useSelector((state) => state.CQA.CQA || { data: [] });

  const [id, setId] = useState(null);
  const [description, setDescription] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    dispatch(fetchCQADescriptionData());
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(CQADescription) && CQADescription.length > 0) {
      const firstDescription = CQADescription[0];
      setId(firstDescription.id || null);
      setDescription(firstDescription.cqa_description || "");
    }
  }, [CQADescription]);

  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!id) {
      alert("ID is missing. Unable to update description.");
      return;
    }

    if (!description.trim()) {
      alert("Description cannot be empty.");
      return;
    }

    setIsUpdating(true);

    try {
      await dispatch(updateCQADescriptionData(id, { cqa_description: description }));
      await dispatch(fetchCQADescriptionData());
      alert("Description updated successfully!");
    } catch (error) {
      alert("An error occurred while updating the description.");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleReset = () => {
    setDescription(CQADescription[0]?.cqa_description || "");
  };

  const modules = {
    toolbar: [
        [{ header: [1, 2, 3, false] }], // Heading styles
        [{ font: [] }], // Font selection
        [{ list: "ordered" }, { list: "bullet" }], // Ordered (numbered) and unordered (bullet) lists
        ["bold", "italic", "underline"], // Font styles
        [{ align: [] }], // Alignment options
        ["clean"], // Clear formatting
    ],
};

const formats = [
    "font",
    "header",
    "list", // Include list format
    "bold",
    "italic",
    "underline",
    "align",

];

  if (loading) {
    return <div className="text-center text-primary-color">Loading...</div>;
  }

  if (error) {
    return (
      <div className="text-center text-red-600">
        <p>Error: {error}</p>
        <p>Please try again later.</p>
      </div>
    );
  }

  if (!Array.isArray(CQADescription) || CQADescription.length === 0) {
    return <div className="text-center text-gray-700">No description available.</div>;
  }

  return (
    <>
        <PageComponent>
    <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
      {/* Sidebar */}
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>
      {/* Main Content */}
      <div className="flex-1 p-6 ml-64">
        <div className="mb-6">
          
          <div className="flex items-center space-x-2 text-3xl text-gray-500">
          <span>Academics & International</span>
          <span>/</span>
          <span className="text-black">Center for Quality Assurance (CQA)</span>
        </div>
        <div className="flex items-center mt-4 space-x-4">
            <button
              className="px-4 py-2 text-white bg-[#92288C] rounded-md shadow hover:bg-[#6C0B67]"
              onClick={() => navigate("/gallery&News/cqa-description")}
            >
              Add Description
            </button>
            <button
              className="px-4 py-2 text-[#92288C] border border-[#92288C] rounded-md shadow hover:bg-gray-100"
              onClick={() => navigate("/gallery&News/add-cqa")}
            >
              Add New Resource
            </button>
            <button
              className="px-4 py-2 text-[#92288C] border border-[#92288C] rounded-md shadow hover:bg-gray-100"
              onClick={() => navigate("/gallery&News/get-cqa")}
            >
              Resource List
            </button>
            <button
              className="px-4 py-2 text-[#92288C] border border-[#92288C] rounded-md shadow hover:bg-gray-100"
              onClick={() => navigate("/gallery&News/cqa-staff")}
            >
              CQA Staff
            </button>
          </div>
        </div>
        <div className="p-6 mt-6 bg-white rounded-lg shadow-md">
          <h2 className="text-2xl font-bold">Edit Description</h2>
          <form onSubmit={handleUpdate}>
            <div className="mt-6 space-y-4">
              <div>
                <label className="block text-gray-700">Description</label>
                 <div className="h-full overflow-y-auto border border-gray-300 rounded-md focus-within:border-gray-400">
                      <ReactQuill
                        id="discription"
                        value={description}
                        onChange={(content) => setDescription(content)}
                        theme="snow"
                        modules={modules}
                        formats={formats}
                        className="h-[300px]"
                        placeholder="Enter description"
                      />
                    </div>
              </div>
            </div>
            <div className="flex justify-end mt-6 space-x-4">
              <button
                type="reset"
                onClick={handleReset}
                className="px-4 py-2 text-[#A8AAAE] bg-gray-200 rounded-md hover:bg-gray-300"
              >
                Reset
              </button>
              <button
                type="submit"
                disabled={isUpdating}
                className={`px-4 py-2 text-white rounded-md ${
                  isUpdating ? "bg-gray-400 cursor-not-allowed" : "bg-[#92288C] hover:bg-[#6C0B67]"
                }`}
              >
                {isUpdating ? "Updating..." : "Update"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </PageComponent>
    </>
  );
}

export default CQAAddDescription;